const videoSeekingSpinnerViewTemplate = () => `<div style="display:none" class="video-seeking-spinner-container">
   <div class="video-seeking-spinner">
      <svg class="spinner-svg" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" >
         <circle class="spinner-circle" cx="40" cy="40" r="35"/>
      </svg>
   </div>
</div>`;

export default videoSeekingSpinnerViewTemplate;
